// Runtime environment resolution — ONE build serves prod and UAT.
//
// The release pipeline builds the SPA once, deploys it to the UAT Hosting
// site, and later CLONES that exact Hosting version to prod. So nothing
// environment-specific may be baked in at build time: the Firebase web
// config and the API base resolve from window.location.hostname here.
// (These are public identifiers — Firestore rules are the boundary.)
//
// localhost / unknown hosts fall back to the CRA .env (REACT_APP_*) so dev
// servers keep working, then to prod.
const ENVS = {
  prod: {
    hosts: ['nventr.io', 'www.nventr.io', 'app.nventr.io', 'nventr-io.web.app', 'nventr-io.firebaseapp.com'],
    api: 'https://api.nventr.io',
    firebase: {
      apiKey: 'AIzaSyD9yfDH22cC5fYdrLUa6_rJ13WnSeru2bk',
      authDomain: 'nventr-io.firebaseapp.com',
      projectId: 'nventr-io',
      storageBucket: 'nventr-io.firebasestorage.app',
      messagingSenderId: '290587996214',
      appId: '1:290587996214:web:6daf15df7a8c1d8e63e897',
    },
  },
  uat: {
    hosts: ['uat.nventr.io', 'app-uat.nventr.io', 'nventr-io-uat.web.app', 'nventr-io-uat.firebaseapp.com'],
    api: 'https://api-uat.nventr.io',
    firebase: {
      apiKey: 'AIzaSyCCYiDmqaFLkdDezfH8x7jCxCweBftTocI',
      authDomain: 'nventr-io-uat.firebaseapp.com',
      projectId: 'nventr-io-uat',
      storageBucket: 'nventr-io-uat.firebasestorage.app',
      messagingSenderId: '742642193931',
      appId: '1:742642193931:web:d7f9982a5b077a95ec590e',
    },
  },
};

const host = typeof window !== 'undefined' ? window.location.hostname : '';
const matched = Object.keys(ENVS).find((k) => ENVS[k].hosts.includes(host));

// 'prod' | 'uat' | 'local'
export const RUNTIME_ENV = matched || 'local';

const fromDotEnv = process.env.REACT_APP_FIREBASE_PROJECT_ID
  ? {
      api: process.env.REACT_APP_UPLOAD_API || '',
      firebase: {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
      },
    }
  : null;

const active = matched ? ENVS[matched] : (fromDotEnv || ENVS.prod);

export const FIREBASE_CONFIG = active.firebase;
// Backend API base (no trailing slash). Empty string = same-origin.
export const API_BASE = String(active.api || '').replace(/\/$/, '');
export const IS_UAT = RUNTIME_ENV === 'uat';
// Where the public site's "Login" sends people. Prod has the dedicated app
// host; UAT (no app-uat DNS yet) and local sign in on the same host — never
// hop planes from a UAT page.
export const LOGIN_URL = RUNTIME_ENV === 'prod' ? 'https://app.nventr.io/login' : '/login';
